<template>
    <div>
<CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>        <!-- <pre class=“language-json”><code>{{ lsAllPayments  }}</code></pre>   -->
        <CCard>
            <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t("paymentSetup.title") }}</strong>
                    </CCol>
                    <p class="desc">{{ $t("paymentSetup.desc") }}</p>
                </CRow>
                <button type="button" class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm"
                        @click="navToAddPayment()">{{ $t("paymentSetup.new") }}
                </button>
            </CCardHeader>


            <CCardBody v-if="lsAllPayments && lsAllPayments.length">
                <!--                <div v-for="(payment, index) in lsAllPayments" :key="index + 'p'" class="payment-type-wrap" >-->
                <!--                    <div class="body option active payment-type">-->
                <!--                        <div class="details">-->
                <!--                            <div class="title m-0">-->
                <!--<img src="https://image.flaticon.com/icons/svg/1085/1085260.svg">-->


                <!--                            <div>   {{ payment.groupName }}</div>-->


                <!--                            </div>-->
                <!--                            &lt;!&ndash; <div class="dec">-->
                <!--                                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus,-->
                <!--                                                            vitae.</p>-->
                <!--                                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>-->
                <!--                                                    </div> &ndash;&gt;-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="payment-wrapper">-->
                <!--                        <draggable-->
                <!--                                :list="payment.paymentSettings"-->
                <!--                                v-if="-->
                <!--            payment && payment.paymentSettings && payment.paymentSettings.length-->
                <!--          "-->
                <!--                                class="options-wrap  row"-->
                <!--                        >-->


                <!--                            <transition-group>-->
                <!--                                <div v-for="(paymentSetting, index) in payment.paymentSettings"-->
                <!--                                     :key="'drag' + index" payment-cel-wrap class="option-wrap">-->
                <!--                                    <div class="option n-active">-->

                <!--<div class="text-tag n-active">-->
                <!--active-->
                <!--</div>-->
                <!--&lt;!&ndash;                                        <div class="tag">&ndash;&gt;-->
                <!--&lt;!&ndash;                                            <img src="@imgPath/img/svg/icons/tick-white.svg" alt />&ndash;&gt;-->
                <!--&lt;!&ndash;                                        </div>&ndash;&gt;-->

                <!--                                        <div @click="navToAddPayment(paymentSetting)">-->
                <!--<div class="logo">-->
                <!--    <img-->
                <!--            src="https://www.wavemoney.com.mm/wp-content/uploads/htd_wm-logo.png"-->
                <!--            alt=""-->
                <!--    />-->
                <!--</div>-->

                <!--                                           <div class="pay-title row"> <div class="col"> {{ paymentSetting.providertype }}</div> <div class="col">-->
                <!--                                               <div class="d-flex flex-flow-wrap justify-center">-->

                <!--                                                   <div class="currency" v-for="(currencyName,-->
                <!--                          index) in paymentSetting.acceptableCurrencies"-->
                <!--                                                        :key="index + 'c'">-->
                <!--                                                       {{ currencyName }},-->
                <!--                                                   </div>-->
                <!--                                               </div>-->
                <!--                                           </div></div>-->

                <!--                                        </div>-->


                <!--                                        &lt;!&ndash; <CCol>-->
                <!--                                              <CCard class="cardWidth">-->
                <!--                                                <CCardBody>-->
                <!--                                                  <CRow style="font-weight: bold ;color: ORANGERED;">-->
                <!--                                                    <CCol>-->
                <!--                                                      {{ paymentSetting.providername }}-->
                <!--                                                    </CCol>-->

                <!--                                                    <CCol>-->
                <!--                                                      <CSwitch-->
                <!--                                                        color="success"-->
                <!--                                                        variant="3d"-->
                <!--                                                        :checked="paymentSetting.isActive"-->
                <!--                                                      >-->
                <!--                                                      </CSwitch>-->
                <!--                                                    </CCol>-->
                <!--                                                  </CRow>-->

                <!--                                                  <br />-->
                <!--                                                  <br />-->
                <!--                                                  <CRow>-->
                <!--                                                    <CCol style="    font-size: 10px;">-->
                <!--                                                      {{ paymentSetting.providertype }}-->
                <!--                                                    </CCol>-->

                <!--                                                    <CCol-->
                <!--                                                      v-for="(currencyName,-->
                <!--                                                      index) in paymentSetting.acceptableCurrencies"-->
                <!--                                                      :key="index + 'c'"-->
                <!--                                                    >-->
                <!--                                                      {{ currencyName }}-->
                <!--                                                    </CCol>-->
                <!--                                                  </CRow>-->
                <!--                                                </CCardBody>-->
                <!--                                              </CCard>-->
                <!--                                            </CCol> &ndash;&gt;-->

                <!--                                    </div>-->

                <!--&lt;!&ndash;                                    <div class="pay-title">&ndash;&gt;-->


                <!--&lt;!&ndash;                                        {{ paymentSetting.providername }}&ndash;&gt;-->


                <!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
                <!--                                </div>-->

                <!--                            </transition-group>-->


                <!--                        </draggable>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div v-for="(payment, index) in lsAllPayments" :key="index + 'p'" class="payment-type-wrap-card">
                    <div class="body option active payment-type">
                        <div class="details">
                            <div class="title m-0">
                                <img src="@imgPath/img/svg/icons/white-house.svg">


                                <div> {{ payment.groupName }}</div>


                            </div>
                            <!-- <div class="dec">
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus,
                                                            vitae.</p>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                                    </div> -->
                        </div>
                    </div>
                    <div class="payment-wrapper">
                        <draggable
                                :list="payment.paymentSettings"
                                v-if="
            payment && payment.paymentSettings && payment.paymentSettings.length
          "
                                class="options-wrap  row"
                        >


                            <transition-group>
                                <div v-for="(paymentSetting, index) in payment.paymentSettings"
                                     :key="'drag' + index" payment-cel-wrap class="option-wrap">
                                    <div  :class="{'n-active':paymentSetting.isActive,'n-inactive':!paymentSetting.isActive}" class="option " @click="navToAddPayment(paymentSetting)">

                                        <div class="text-tag " :class="{'n-active':paymentSetting.isActive,'n-inactive':!paymentSetting.isActive}" >
                                          {{paymentSetting.isActive? $t('paymentSetup.active') : $t('paymentSetup.inactive')}}
                                        </div>
                                        <div class="main-con">
                                            <div class="logo-text">
                                                <div class="logo">
                                                    <img :src="paymentSetting.logourl" alt="">
                                                </div>
                                                <div class="text">
                                                    <div class="title">
                                                        {{ paymentSetting.providername }}
                                                    </div>
                                                    <div class="dec">
                                                        {{ paymentSetting.providertype }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="status">

                                            </div>
                                        </div>
                                       <div class="bottom">
                                           <div class="stag">
                                               <div class="s-tag" :class="{'stag':!paymentSetting.isproduction,'prod':paymentSetting.isproduction }">
                                                {{paymentSetting.isproduction?$t('paymentSetup.production'):$t('paymentSetup.staging')}}     
                                               </div>
                                           </div>
                                           <div class="currecny-list">
                                               <div class="invi" v-for="(currencyName,
                          index) in paymentSetting.acceptableCurrencies"
                                                    :key="index + 'c'" >
                                                   {{ currencyName }}
                                               </div>

                                               <!--                                            <div class="invi">-->
                                               <!--                                                3 <div>More</div>-->
                                               <!--                                            </div>-->
                                           </div>
                                       </div>


                                        <!--                                        <div class="tag">-->
                                        <!--                                            <img src="@imgPath/img/svg/icons/tick-white.svg" alt />-->
                                        <!--                                        </div>-->

<!--                                        <div @click="navToAddPayment(paymentSetting)">-->
<!--                                            <div class="logo">-->
<!--                                                <img-->
<!--                                                        src="https://www.wavemoney.com.mm/wp-content/uploads/htd_wm-logo.png"-->
<!--                                                        alt=""-->
<!--                                                />-->
<!--                                            </div>-->

<!--                                            <div class="pay-title row">-->
<!--                                                <div class="col"> {{ paymentSetting.providertype }}</div>-->
<!--                                                <div class="col">-->
<!--                                                    <div class="d-flex flex-flow-wrap justify-center">-->

<!--                                                        <div class="currency" v-for="(currencyName,-->
<!--                          index) in paymentSetting.acceptableCurrencies"-->
<!--                                                             :key="index + 'c'">-->
<!--                                                            {{ currencyName }},-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->

<!--                                        </div>-->


                                        <!-- <CCol>
                                              <CCard class="cardWidth">
                                                <CCardBody>
                                                  <CRow style="font-weight: bold ;color: ORANGERED;">
                                                    <CCol>
                                                      {{ paymentSetting.providername }}
                                                    </CCol>

                                                    <CCol>
                                                      <CSwitch
                                                        color="success"
                                                        variant="3d"
                                                        :checked="paymentSetting.isActive"
                                                      >
                                                      </CSwitch>
                                                    </CCol>
                                                  </CRow>

                                                  <br />
                                                  <br />
                                                  <CRow>
                                                    <CCol style="    font-size: 10px;">
                                                      {{ paymentSetting.providertype }}
                                                    </CCol>

                                                    <CCol
                                                      v-for="(currencyName,
                                                      index) in paymentSetting.acceptableCurrencies"
                                                      :key="index + 'c'"
                                                    >
                                                      {{ currencyName }}
                                                    </CCol>
                                                  </CRow>
                                                </CCardBody>
                                              </CCard>
                                            </CCol> -->

                                    </div>

                                    <!--                                    <div class="pay-title">-->


                                    <!--                                        {{ paymentSetting.providername }}-->


                                    <!--                                    </div>-->
                                </div>

                            </transition-group>


                        </draggable>
                    </div>
                </div>

            </CCardBody>
            <br/>
            <br/>
            <CCardFooter class="d-flex justify-content-end">
                <CRow>
                    <CCol>
                        <CButton
                                color="success"
                                type="submit"
                                class="action-c-btn pl-20px" @click="savePaymentListOrder(lsAllPayments)"

                        >
                            <img src="@imgPath/img/svg/icons/save.svg" height="16px" class="height-unset"/>
                            {{ $t("paymentSetup.save") }}
                        </CButton>

                        <!-- <CButton @click="onPermissionsFormSave(lsModulesPermissions)" color="success">
                                    {{$t('rolesPermissions.save')}}
                        </CButton>-->
                    </CCol>
                </CRow>
            </CCardFooter>

        </CCard>

        <cAlertModal
                v-if="isShowAlertModal"
                :buttonList="getAlertModalBtn()"
                :status="1"
                :show="isShowAlertModal"
                :desc="$t('paymentSetup.updateStatus')"
        >
        </cAlertModal>
    </div>
</template>
<script>
    import cDropDown from "./../../components/form/cDropDown";
    import cTextInputComponent from "./../../components/form/cTextInputComponent";

    import cAlertModal from "./../../components/form/cAlertModal";
    import Multiselect from "vue-multiselect";
    import router, {navigate, goBack,updateDataEdited} from "../../router/index";
    import {
        cloneData,
        removeDuplicates,
        OrderByList,
        addClassToBody,
        removeClassBody
    } from "./../../util/util";
    import {ValidationObserver} from "vee-validate";
    import {mapGetters, mapActions} from "vuex";
    import draggable from "vuedraggable";
    import {
        PATHNAME,
        COMPONENT_NAME,
        DEFAULT_DROPDOWN_STATUS
    } from "./../../util/constants";
    import apiGetAllPayments from "./../../services/apiGetAllPayments";
    import apiSwapPaymentSettings from "./../../services/apiSwapPaymentSettings";
    import Logger from "./../../services/logger";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES,
        API_VALUES
    } from "./../../config/API_DATA";
    import BaseConfiguration from "./../../config/base";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {handleJWT, getErrorAlertValue} from "../../util/util";

    // import nb from "../../translations/validation/nb.json";
    // import en from "../../translations/validation/en.json";

    export default {
        name: COMPONENT_NAME.PAYMENT_SETUP,

        components: {
            draggable,
            cAlertModal
        },

        data: () => {
            return {
                lsAllPayments: [],
                alertValue: null,
                isShowAlertModal: false
            };
        },

        methods: {
            ...mapActions("sPaymentSetup", {
                SET_SELECTED_PAYMENT: "SET_SELECTED_PAYMENT"
            }),

            navToAddPayment(pPayment) {
                this.SET_SELECTED_PAYMENT(pPayment);
                navigate(PATHNAME.ADD_PAYMENT);
            },

            getAlertModalBtn() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getAlertModalBtn");

                    retValue = [
                        {
                            name: this.$t("addPayment.ok"),
                            func: this.toggleAlertModal
                        }
                    ];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in getAlertModalBtn",
                        err.toString(),
                        "getAlertModalBtn",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            toggleAlertModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
                    this.isShowAlertModal = !this.isShowAlertModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in toggleAlertModal",
                        err.toString(),
                        "toggleAlertModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getSwapPaymentReq(pPaymentList) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getSwapPaymentReq");
                    if (pPaymentList && pPaymentList.length) {
                        pPaymentList.forEach(payment => {
                            if (
                                payment &&
                                payment.paymentSettings &&
                                payment.paymentSettings.length
                            ) {
                                payment.paymentSettings.forEach((pSett, index) => {
                                    pSett.displayorder = index;
                                    retValue.push({
                                        paymentSettingId: pSett.paymentsettingsid,
                                        displayOrder: pSett.displayorder
                                    });
                                });
                            }
                        });
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in getSwapPaymentReq",
                        err.toString(),
                        "getSwapPaymentReq",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async savePaymentListOrder(lsAllPayments) {
                try {
                    if (BaseConfiguration.isDebug) console.log("savePaymentListOrder");

                    if (lsAllPayments && lsAllPayments.length) {
                        let swapPaymentsReq = apiSwapPaymentSettings.buildRequest(
                            this.getSwapPaymentReq(cloneData(lsAllPayments))
                        );

                        if (swapPaymentsReq) {
                            let swapPaymentsRes = await apiSwapPaymentSettings.getResponse(
                                swapPaymentsReq
                            );
                            if (VALIDATE_SUCCESS_RES(swapPaymentsRes)) {
                                this.toggleAlertModal();

                                this.alertValue = null;
                            } else {
                                let error = getErrorMessage(swapPaymentsRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invalid payment request";
                        }
                    } else {
                        throw "invalid payment list";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in savePaymentListOrder",
                        err.toString(),
                        "savePaymentListOrder",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            sortPaymentList(pPaymentList) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("sortPayments");
                    if (pPaymentList && pPaymentList.length) {
                        pPaymentList = OrderByList(this.lsAllPayments, "groupName", "asc");

                        pPaymentList.forEach(payment => {
                            payment.paymentSettings = OrderByList(
                                payment.paymentSettings,
                                "displayorder",
                                "asc"
                            );
                        });

                        retValue = pPaymentList;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in sortPayments",
                        err.toString(),
                        "sortPayments",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async getAllPayments() {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getAllPayments");

                    let allPaymentsReq = apiGetAllPayments.buildRequest();

                    if (allPaymentsReq) {
                        let allPaymentsRes = await apiGetAllPayments.getResponse(
                            allPaymentsReq
                        );
                        if (VALIDATE_SUCCESS_RES(allPaymentsRes)) {
                            if (
                                allPaymentsRes &&
                                allPaymentsRes.data.data &&
                                allPaymentsRes.data.data.length
                            )
                                retValue = allPaymentsRes.data.data;
                            else retValue = [];
                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(allPaymentsRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid payment request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAYMENT_SETUP,
                        "error in getAllPayments",
                        err.toString(),
                        "getAllPayments",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            }
        },

        async created() {
            try {
                if (BaseConfiguration.isDebug) console.log("created");

                this.lsAllPayments = await this.getAllPayments();
                this.lsAllPayments = this.sortPaymentList(this.lsAllPayments);
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.PAYMENT_SETUP,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.PAYMENT_SETUP);
        },

        beforeDestroy() {
            removeClassBody();
        }
    };
</script>
<style scoped>
    .cardWidth {
        width: 200px;
    }
</style>
